export default __webpack_public_path__ + "static/media/Rajeev_Kapoor.c70cbf13.png";